<div class="tabview-panel" role="tabpanel" [hidden]="!(isSelected | async)">
  <ng-content />
</div>
